import React, { useState } from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { MdKeyboardArrowDown } from "react-icons/md";

import { images } from "../constants";

import { useTranslation } from "react-i18next";

import { enableScroll, disableScroll } from "../utils/scrollFuncions";

import { getDomainWithLanguageURL, getIndexPath } from "../utils/languageFunctions";


const navItemsInfo = [
    {name: "Home", type: "link", link: "/"},
    {name: "Language", type: "dropdown", items: ["English", "Español"]},
    {name: "Archive", type: "link", link: "/archive"},
    {name: "About Us", type: "link", link: "/about"},
]

const passParamToNextLink = (link) => {

    // Check language: Ver si esta en la página en español (lee el url y checa que el valor del path index 0 sea 'es'). 
    let indexPath = getIndexPath();


    if(indexPath.substring(0,3) === "/es"){ // Si el lenguaje actual es español, entonces
        
        window.location.href = process.env.REACT_APP_DOMAIN_URL + "/es" + link;

    }else{ // Si el lenguaje actual es inglés, entonces
       
        window.location.href = process.env.REACT_APP_DOMAIN_URL + link;  
    }
};

const NavItem = ({ item }) => {

    const setLanguage = (lang) => {

        // Check language: Ver si esta en la página en español (lee el url y checa que el valor del path index 0 sea 'es'). 
        let indexPath = getIndexPath();

        
        if(indexPath.substring(0,3) === "/es"){ // Si el lenguaje actual es español, entonces
            console.log("PAGINA EN ESPAÑOL");

            // Si el lenguaje que esta seleccionando es Inglés, entonces cambiar el nextPath al formato de path en inglés. (Uniendo partes que ya habia eliminado)
            if(lang === "English"){

                // Quitar el "/es" del path, e ir a esa página.
                indexPath = indexPath.replace('/es', '');
                window.location.href = process.env.REACT_APP_DOMAIN_URL + indexPath;  
            }


        }else{ // Si el lenguaje actual es inglés, entonces
            console.log("PAGINA EN INGLES");

            // si el lenguaje que esta seleccionando es Español, entonces cambiar el nextPath al formato de path en español. (Uniendo partes que ya habia eliminado)
            if(lang === "Español"){

                // Poner el /es en path, e ir a esa página.
                console.log(process.env.REACT_APP_DOMAIN_URL + "/es" + indexPath);

                window.location.href = process.env.REACT_APP_DOMAIN_URL + "/es" + indexPath;
            }
        }
    };


    const { t } = useTranslation();

    const [dropdown, setDropdown] = useState(false);
    
    const toggleDropdownHandler = () => {
        setDropdown((curState) => {
    
            return !curState;
        });
    };    

    return (
        <li className="relative group">
            {item.type === "link" ? (
                <p onClick={() =>  window.location.href = getDomainWithLanguageURL() + item.link} className="px-4 py-2 hover:text-blue-900 hover:transition-all duration-500">
                    {t(item.name)}
                </p>
            ) : (
                <div className="flex flex-col items-center">
                    <button className="px-4 py-2 flex gap-x-1 items-center hover:text-blue-900 hover:transition-all duration-500" onClick={toggleDropdownHandler}>
                        {t(item.name)}
                        <MdKeyboardArrowDown />
                    </button>
                    <div className={`${dropdown ? "block" : "hidden"} md:hidden transition-all duration-500 pt-4 md:absolute md:bottom-0 md:right-0 md:transform md:translate-y-full md:group-hover:block w-max`}>
                        
                        <ul className="bg-white text-center flex flex-col shadow-lg rounded-lg overflow-hidden">
                            {item.items.map((page, index) => (
                                <button key={index} onClick={() => setLanguage(page)} className="hover:bg-blue-900 hover:text-white px-4 py-2 text-dark-soft">
                                    {page}
                                </button>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </li>
    );
};



const Header = () => {

    const [navIsVisible, setNavIsVisible] = useState(false);

    const navVisibilityHandler = () => {
        setNavIsVisible((curState) => {

            // Funciones para activar y desactivar el scroll cuando el menu de small devices este presente 
            if(curState){   
                enableScroll();
            }else{
                window.scrollTo(0, 0);  // Ir a la parte superior de la página para que no se note que el menu de small devices
                                        // se vea una parte blanca, cuando se activa mientras el scroll esta un poco abajo.
                disableScroll();
            }

            return !curState;
        })
    };

    return <section className="top-0 left-0 right-0 z-50 bg-[#4F83FF]">
        <header className="container mx-auto px-5 flex justify-between py-2 items-center">
            <div>
                <img onClick={() => passParamToNextLink('')} 
                    className="w-56" src={images.Logo} alt="" />
            </div>
            <div className="md:hidden z-55"> 
                {navIsVisible ? (
                    <AiOutlineClose 
                        className="w-6 h-6 text-white"
                        onClick={navVisibilityHandler}
                    />
                    
                ) : (
                    <AiOutlineMenu className="w-6 h-6 text-white" onClick={navVisibilityHandler} /> 
                )} 
            </div>
            <div 
                className={`${
                    navIsVisible ? "right-0" : "-right-full" 
                } transition-all duration-300 mt-[60px] md:mt-0 bg-[#4F83FF] md:bg-transparent z-[54] flex flex-col w-full md:w-auto justify-center md:justify-end md:flex-row fixed top-0 bottom-0 md:static gap-x-9 items-center`}
            >

                <ul className="text-white items-center gap-y-5 flex flex-col md:flex-row gap-x-2 font-semibold">
                    {navItemsInfo.map((item) => (
                        <NavItem key={item.name} item={item} />
                    ))}
                </ul>
            </div>
        </header>
    </section>;
}; 

export default Header; 